export function calculateOverallScore(manuscript) {
    let sum = 0;
    let count = 0
    if (manuscript.noveltyScore != null && manuscript.noveltyScore !== undefined) {
        sum += manuscript.noveltyScore;
        count++;
    }
    if (manuscript.impactScore != null && manuscript.impactScore !== undefined) {
        sum += manuscript.impactScore;
        count++;
    }
    if (manuscript.methodScore != null && manuscript.methodScore !== undefined) {
        sum += manuscript.methodScore;
        count++;
    }

    return sum > 0 && count > 0 ? Math.round(sum / count) : 0;
}